import React, { Component } from "react";
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import redirectURL from '../redirectURL';
import moment from 'moment';

class EnmUserLogin extends Component {
    constructor(props) {
        super(props);
        this.state = { successLogin: 0 };
    }

    async componentDidMount() {
        const token = window.location.pathname.split("/")[2]
        const query = {
            token: token
        };
        try {
            const res = await redirectURL.post("/authenticateUserToken", query);
            if (res.status === 200) {
                if (res.data.auth) {
                    if (res.data.otpAuthentication === 1) {
                        this.setState({
                            otpAuthentication: res.data.otpAuthentication,
                            otpMessage: "OTP has been sent to your Email",
                            userData: res.data,
                            successLogin: 0,
                        });
                    } else {
                        this.setState({
                            "successLogin": 1,
                        })
                        let md = this.cipher("Z744cRBHMjQTsi6cOlNaRKauSEF6MiEr");
                        let r = md(res.data.email)
                        let d = md(res.data.password)
                        await redirectURL.post("/verifyUserEnmovil", {
                            e: r,
                            d: d
                        })
                            .then((response) => {
                                if (response.data.status == "success") {
                                    var decode = this.decipher("Z744cRBHMjQTsi6cOlNaRKauSEF6MiEr");
                                    localStorage.setItem("k", response.data.output);
                                    var c = moment.parseZone().format("YYYY-MM-DD")
                                    var s = moment.parseZone().format("HH:mm:ss")
                                    localStorage.setItem("date", c);
                                    localStorage.setItem("time", s);
                                    localStorage.setItem("dept_code", "SNDG")
                                    localStorage.setItem("transportercode", JSON.stringify(["ENM135"]))
                                    localStorage.setItem('lastActivityTime', '');
                                    localStorage.setItem('logoutuser', '3232343232323');
                                    this.setState({
                                        isNav: true,
                                    })
                                }
                                else {
                                    this.setState({
                                        show: true,
                                        title: "Invalid Email / Password.",
                                        style: { display: 'none' },
                                        style2: { display: 'block' },
                                    })
                                }
                            }).catch(err => console.log(err))
                    }
                } else {
                    this.setState({
                        username: '',
                        email: '',
                        password: '',
                        loginMessage: res.data.msg
                    });
                }
            } else {
                this.setState({
                    username: '',
                    email: '',
                    password: '',
                    loginMessage: res.data.msg
                });
            }
        } catch (error) {
            console.error("Error authenticating user:", error);
        }
    }

    getUserDashboardUrl(pathToMatch = null) {
        window.location.href = "/"
        // if (localStorage.getItem("roles").indexOf("AMNS_OPS_SC") >= 0) {
        //     var dashboardUrl = "sndtrucks";
        // }
        // else if (localStorage.getItem("roles").indexOf("AMNS_OPS") >= 0) {
        //     var dashboardUrl = "shipmenttrucks";
        // }
        // else if (localStorage.getItem("roles").indexOf("security") >= 0) {
        //     var dashboardUrl = "securitydashboard";
        // }
        // else if (localStorage.getItem("roles").indexOf("vehicletrackingreport") >= 0) {
        //     var dashboardUrl = "tpttruckgpsstatus";
        // }
        // else if (localStorage.getItem("user_type") == "CUSTOMER") {
        //     var dashboardUrl = "customertrucks";
        // }
        // else if (localStorage.getItem("user_type") == "MARKETING" && localStorage.getItem("pc") != "HZ") {
        //     var dashboardUrl = "customertrucks"
        // }
        // else if (localStorage.getItem("roles") == "MARKETING_SC") {
        //     var dashboardUrl = "customertrucks"
        // }
        // else if (localStorage.getItem("roles").indexOf("RAIL") >= 0) {
        //     var dashboardUrl = "rail-consignments/default";
        // }
        // else if (localStorage.getItem("roles").indexOf("TRANSPORTER") >= 0) {
        //     var dashboardUrl = "sndtranshipments";
        // }
        // else if (localStorage.getItem("roles").indexOf("sim_tracking") >= 0) {
        //     var dashboardUrl = "simtrackingjioandtelenitylogs";
        // }
        // else {
        //     var dashboardUrl = "shipmenttrucks";
        // }
        // if (localStorage.getItem("email") == "simtracking@enmovil.in") {
        //     var dashboardUrl = "simtrackingdashboard"
        // }

        // let currentDepartmentCode = null;
        // let departmentCode = JSON.parse(localStorage.getItem("dept_code"));

        // //console.log("IN render, departmentCode ", departmentCode);
        // if (Array.isArray(departmentCode)) {
        //     currentDepartmentCode = departmentCode[0];
        // } else {
        //     currentDepartmentCode = departmentCode;
        // }
        // console.log("dashboardUrl Login", dashboardUrl)
        // return dashboardUrl;
    }



    cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);

        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }

    decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }

    render() {
        if (localStorage.getItem('k') != '' && localStorage.getItem('k') != null) {
            var successLogin = this.state.successLogin;
            if (successLogin == 1) {
                let dashboardUrl = this.getUserDashboardUrl();
                return <Navigate to={"/" + dashboardUrl} push={true} />
            }
        }
        return (
            <div>
                <div className="loader-wrapper">
                    <div className="loader bg-white">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <h4>Authenticating... <span>&#x263A;</span></h4>
                    </div>
                </div>
            </div>
        );
    }
}

export default EnmUserLogin;